import React from "react";
import RightPannel from "../../../components/RightPannel";
import { useNavigate } from "react-router-dom";
import MyContacts from "../../../../../Diathrive/src/containers/MyContacts";
import { useDisableBodyScroll } from "../../../../../Diathrive/src/hooks/use-disable-dody-scroll";

const MyContactsWeb = ({ openContacts, setOpenContacts }) => {
  const navigate = useNavigate();

  //hook to disable scrolling for web
  useDisableBodyScroll(openContacts);

  return (
    <RightPannel
      componentToPassDown={
        <MyContacts
          navigation={navigate}
          onClose={setOpenContacts}
          route={{}}
        />
      }
      open={openContacts}
      onClose={() => setOpenContacts(false)}
    />
  );
};

export default MyContactsWeb;
